import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Famous is read live, over an SSH tunnel, so vouchers are cached for a few
 * minutes and never refetched on window focus. The section's Refresh button
 * forces a read.
 */
const FAMOUS_VOUCHERS_STALE_MS = 5 * 60_000;

/**
 * The Famous vouchers for an AP invoice (live, read-only), newest first, with
 * each voucher's lines grouped by load / order / PO and what it covers.
 */
export function useAPInvoiceFamousVouchers(
  apInvoiceId: string | undefined,
  enabled = true,
) {
  const query = useQuery({
    ...orpc.accountsPayable.invoices.listFamousVouchers.queryOptions({
      input: apInvoiceId ? { apInvoiceId } : skipToken,
    }),
    enabled: Boolean(apInvoiceId) && enabled,
    staleTime: FAMOUS_VOUCHERS_STALE_MS,
    refetchOnWindowFocus: false,
  });
  return {
    data: query.data,
    vouchers: query.data?.vouchers ?? [],
    isPending: query.isPending,
    isError: query.isError,
    isFetching: query.isFetching,
    refetch: query.refetch,
  };
}
